import { atom } from "recoil";

export interface HeaderTrades {
  total_strategies: number;
  total_live_strategies: number;
  total_trades: number;
  total_volume: number;
  netPosition_broker: number;
  total_exposure: number;
  net_cumulative_profit: number;
  broker_WinPercent: number;
  loading: boolean;
}

const defaultHeaderTrades: HeaderTrades = {
  total_strategies: 0,
  total_live_strategies: 0,
  total_trades: 0,
  total_volume: 0,
  netPosition_broker: 0,
  total_exposure: 0,
  net_cumulative_profit: 0,
  broker_WinPercent: 0,
  loading: true,
};

export const headerTradesState = atom({
  key: "headerTrades",
  default: defaultHeaderTrades,
});
